module.exports = __webpack_public_path__ + "static/media/img21_LV.cb630e6a.png";